module.exports = __webpack_public_path__ + "img/invitation.f3bf36c1.png";